import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Box, Button, Container, Drawer, MenuItem, TextField, Typography, } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useList } from './ListContext';
export var OrderComponent = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'white' : _b;
    var _c = useList(), order = _c.order, setOrder = _c.setOrder;
    var searchParams = useSearchParams()[0];
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var _e = useState(order), selectedOrder = _e[0], setSelectedOrder = _e[1];
    useEffect(function () {
        var currentOrder = searchParams.get('order') || 'asc';
        setSelectedOrder(currentOrder);
    }, [searchParams]);
    var toggleDrawer = function (isOpen) { return function () {
        setOpen(isOpen);
    }; };
    var handleOrderChange = function (value) {
        setSelectedOrder(value);
    };
    var handleConfirm = function () {
        setOrder(selectedOrder);
        setOpen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, { variant: "outlined", onClick: toggleDrawer(true), sx: {
                    color: color === 'white' ? '#FFFFFF' : 'primary.main',
                    borderColor: color === 'white' ? '#FFFFFF' : 'primary.main',
                    borderRadius: '30px',
                    textTransform: 'none',
                    padding: '0.5em 1.5em',
                    fontSize: '.7rem',
                    '& + &': {
                        marginLeft: '1rem',
                    },
                }, endIcon: _jsx(ArrowDropDownIcon, { sx: { color: '#A2B6DF' } }), children: "Ordenar" }), _jsx(Drawer, { anchor: "bottom", open: open, onClose: toggleDrawer(false), children: _jsxs(Container, { sx: { padding: '4rem 2rem' }, children: [_jsx(Typography, { variant: "h6", gutterBottom: true, children: "Ordenar" }), _jsxs(TextField, { label: "Ordenar por", select: true, fullWidth: true, sx: { mt: 2 }, value: selectedOrder, onChange: function (e) { return handleOrderChange(e.target.value); }, children: [_jsx(MenuItem, { value: "desc", children: "Mais recente" }), _jsx(MenuItem, { value: "asc", children: "Mais antigo" })] }), _jsxs(Box, { sx: { marginTop: 2 }, children: [_jsx(Button, { variant: "contained", onClick: handleConfirm, sx: { mr: 2 }, children: "CONFIRMAR" }), _jsx(Button, { variant: "text", onClick: toggleDrawer(false), children: "VOLTAR" })] })] }) })] }));
};
